var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',[_vm._v("請求書・領収書の発行")]),_c('form-input')],1)}
var staticRenderFns = []

export { render, staticRenderFns }